/**
 * siteBackground.js
 *
 * Single source of truth for #SiteBackground opacity mutations.
 * Both Home.js (section transitions) and SiteBackground.js (route changes)
 * must use setSiteBackgroundOpacity() instead of calling gsap.to('#SiteBackground')
 * directly. This prevents two independent GSAP tweens from fighting on the
 * same property when a route change coincides with a section scroll.
 */
import gsap from 'gsap';

/**
 * Returns the target opacity for #SiteBackground for a given section index.
 * Desktop: visible on sections 0–2 (Home / Work / Lab), hidden on 3 (About).
 * Mobile:  always hidden — no section requires a visible background on mobile.
 *
 * @param {number} sectionIndex
 * @param {boolean} isMobile
 * @returns {number}
 */
export function getBackgroundOpacity(sectionIndex, isMobile) {
    if (isMobile) {
        return 0.0;
    }
    return sectionIndex !== 3 ? 0.89 : 0.0;
}

/**
 * Animate #SiteBackground to the given opacity.
 * Kills any existing tween on this element first to prevent fights.
 *
 * @param {number} opacity   Target opacity value.
 * @param {number} duration  Animation duration in seconds.
 * @param {number} [delay]   Optional GSAP delay.
 * @param {string} [ease]    Optional GSAP ease. Omit to keep GSAP's default
 *                           (preserves existing behavior for section-scroll callers).
 */
export function setSiteBackgroundOpacity(opacity, duration, delay = 0, ease) {
    const el = document.getElementById('SiteBackground');
    if (!el) return;
    gsap.killTweensOf(el);
    const vars = { opacity, duration, delay, overwrite: 'auto' };
    if (ease) vars.ease = ease;
    gsap.to(el, vars);
}
